'use client'
import { Box, Grid, IconButton, iconButtonClasses, Stack, styled } from '@mui/material'
import React from 'react'
import { IDailySale, IDailySaleItem } from '../types/trend-product'
import { EmptyContent } from '@/components'
import { SwiperSlide, Swiper } from 'swiper/react'
import { ProductItem, ProductLoading, useProducts } from '@/features/products'
import { Navigation, Pagination } from 'swiper/modules'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
interface SwiperProps {
  rows?: number
}
interface SwiperSlideStyleProps {
  itemsPerViewPc?: number
  itemsPerViewTablet?: number
  itemsPerViewMobile?: number
  customWidth?: string
  padding?: number
}
interface NavButtonProps {
  isLeft?: boolean
  isRight?: boolean
}
type Props = {
  products?: Product[]
  classContainer?: string
  isSale?: boolean
  classSwiper: string
  slidesPc?: number
  slidesTablet?: number
  slidesMobile?: number
  productsSale?: IDailySaleItem[]
}
export default function ProductSlide({
  products,
  classSwiper,
  slidesPc,
  slidesTablet,
  slidesMobile,
  productsSale,
}: Props) {
  return (
    <Box position={'relative'} overflow={'hidden'} className={classSwiper}>
      <SwiperStyle
        slidesPerView={'auto'}
        modules={[Navigation]}
        pagination={{ clickable: true }}
        navigation={{
          prevEl: `.${classSwiper} .swiper-btn-prev`,
          nextEl: `.${classSwiper} .swiper-btn-next`,
        }}
        spaceBetween={0}
        watchSlidesProgress
      >
        {products?.map((item) => (
          <SwiperSlideStyle
            key={item.uid}
            itemsPerViewPc={slidesPc}
            itemsPerViewTablet={slidesTablet}
            itemsPerViewMobile={slidesMobile}
          >
            <ProductItem
              cardProps={{
                sx: {
                  minWidth: 'unset',
                },
              }}
              product={item}
            />
          </SwiperSlideStyle>
        ))}
        {productsSale?.map((item) => {
          return (
            <SwiperSlideStyle
              key={item.product.uid}
              itemsPerViewPc={slidesPc}
              itemsPerViewTablet={slidesTablet}
              itemsPerViewMobile={slidesMobile}
            >
              <ProductItem
                cardProps={{
                  sx: {
                    minWidth: 'unset',
                  },
                }}
                product={item?.product}
                salesInfo={item}
              />
            </SwiperSlideStyle>
          )
        })}
      </SwiperStyle>
      <SwiperNavButton isLeft={true} className={`${classSwiper} swiper-btn-prev`}>
        <ArrowBackIosNewRoundedIcon fontSize="small" />
      </SwiperNavButton>
      <SwiperNavButton isRight={true} className={`${classSwiper} swiper-btn-next`}>
        <ArrowForwardIosRoundedIcon fontSize="small" />
      </SwiperNavButton>
    </Box>
  )
}
export const SwiperStyle = styled(Swiper)<SwiperProps>(({ theme, rows = 16 }) => ({
  margin: `0 -${rows / 2}px`,
}))

export const SwiperSlideStyle = styled(SwiperSlide, {
  shouldForwardProp: (prop) =>
    prop !== 'itemsPerViewPc' &&
    prop !== 'itemsPerViewTablet' &&
    prop !== 'itemsPerViewMobile' &&
    prop !== 'customWidth' &&
    prop !== 'padding',
})<SwiperSlideStyleProps>(
  ({
    theme,
    itemsPerViewPc = 4,
    itemsPerViewTablet = 2,
    itemsPerViewMobile = 1,
    customWidth,
    padding = 16,
  }) => ({
    width: customWidth ? customWidth : `calc(100% / ${itemsPerViewPc})`,
    padding: `0 ${padding / 2}px`,
    height: 'auto',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xl')]: {
      padding: `0 ${padding / 2}px`,
      width: customWidth ? customWidth : `calc(100% / ${itemsPerViewTablet})`,
    },
    [theme.breakpoints.down('md')]: {
      width: customWidth ? customWidth : `calc(100% / ${itemsPerViewMobile})`,
    },
  })
)
export const SwiperNavButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isLeft' && prop !== 'offset',
})<NavButtonProps>(({ theme, isLeft, isRight }) => ({
  position: 'absolute',
  top: '50%',
  transform: `translateY(-50%)`,
  zIndex: 10,
  backgroundColor: '#fff',
  color: '#C84B00',
  width: 25,
  height: 50,

  borderRadius: `${isLeft ? '0 8px 8px 0' : '8px 0 0 8px'}`,
  left: isLeft ? '0' : undefined,
  right: isRight ? '0' : undefined,
  transition: 'all 0.3s ease',

  '&.swiper-button-disabled': {
    opacity: 0,
    pointerEvents: 'none',
  },
}))
